import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import EventsPage from "./pages/EventsPage";
import ServicesPage from "./pages/ServicesPage";
import ClientsPage from "./pages/ClientsPage";
import TestimonialPage from "./pages/TestimonialPage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import RegistrationFeePage from "./pages/RegistrationFeePage";
import WinnerPackagePage from "./pages/WinnerPackagePage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import JuryTermsPage from "./pages/JuryTermsPage";
import WinnerPackageTermsPage from "./pages/WinnerPackageTermsPage";
import RefundAgreementPage from "./pages/RefundAgreementPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiesPolicyPage from "./pages/CookiesPolicyPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#0a0a0a]">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/testimonials" element={<TestimonialPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/registration-fee" element={<RegistrationFeePage />} />
            <Route path="/winner-package" element={<WinnerPackagePage />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
            <Route path="/jury-terms-and-conditions" element={<JuryTermsPage />} />
            <Route path="/winner-package-terms-and-conditions" element={<WinnerPackageTermsPage />} />
            <Route path="/refund-agreement" element={<RefundAgreementPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/cookies-policy" element={<CookiesPolicyPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
  );
}

export default App;
